/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsForgotPassword204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsForgotPassword505Schema = z.any();

export const optionsForgotPasswordMutationResponseSchema = z.lazy(() => optionsForgotPassword204Schema);
